var site = site || {};

(function ($) {
  Drupal.behaviors.sppCrossSellsV1 = {
    attach: function (context) {
      if (this.attached) {
        return;
      }
      this.attached = true;

      var $template = $('.js-spp-cross-sells-v1', context);
      var $skucard = $('.js-sku-card', $template);
      var $grid = $('.js-product-grid-products--carousel', $template);

      if ($grid.length > 0) {
        site.productCarousel.init($grid);
      }

      // @todo see if we need to keep this, or let product_brief_v2 handle this internally
      // duped from bb_base/template_api/editorial/editorial_grid_products_v1/src/editorial_grid_products_v1.js
      // this will be executed only when sku card is enabled in CMS
      if ($skucard.length > 0) {
        $skucard.each(function () {
          var $this = $(this);
          var shade = $this.data('shade-name');

          // removing shade numbers (skin foundation shades)
          shade = shade.replace(/[0-9.()]+$/g, '');
          var shadeName = shade.split(' ').join('_');
          var $anchorLink = $this.find('.js-sku-image-link');

          $anchorLink.each(function () {
            var $thisLink = $(this);
            var oldLink = $thisLink.attr('href');
            var newLink = oldLink + '#/shade/' + shadeName;

            $thisLink.attr('href', newLink);
          });
        });
      }
    },
    attached: false
  };
})(jQuery);
